/**
 *  @class
 *  @function CollectionScroll
 */
if (!customElements.get('collection-scroll-lg')) {
    class CollectionScroll extends HTMLElement {
      constructor() {
        super();
  
        this.viewport = this.querySelector('.theme-scroll--inner');
        this.slideWidth = 274;
        this.slidesToScroll = 1;
      }
      connectedCallback() {
        // window.OverlayScrollbarsGlobal.OverlayScrollbars({
        //   target: this,
        //   elements: {
        //     viewport: this.viewport,
        //   }
        // }, {});
  
        this.init();
      }
      init() {
        this.setSlides();
        this.reachedEnd = 0;
  
        if (this.slides.length < 1) {
          return;
        }
        this.nav = this.querySelector('.theme-scroll-nav');
        this.navPrev = this.querySelector('.flickity-prev');
        this.navNext = this.querySelector('.flickity-next');
        this.resizeObserver = new ResizeObserver((entries) => {
          this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
          this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth - this.viewport.scrollLeft <= 1;
          this.onNavDisabled();
        }, {
          root: this
        });
        const debounceFn = (typeof debounce === 'function') ? debounce : FoxTheme.utils.debounce;
        this.debouncedOnScroll = debounceFn((event) => {
          this.onScroll(event);
        }, 100);
  
        this.setListeners();
        this.centerArrows();

        // Enable nav buttons initially based on slide count
        if (this.navPrev) this.navPrev.disabled = true;
        if (this.navNext) this.navNext.disabled = this.viewport.scrollWidth <= this.viewport.offsetWidth;

        // Recheck after layout settles
        setTimeout(() => {
          this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth <= 1;
          this.onNavDisabled();
        }, 300);
      }
      setSlides() {
        this.slides = this.querySelectorAll('.carousel__slide');
        this.slidesLength = this.slides.length;
        this.lastSlide = this.slides[this.slides.length - 1];
      }
      setListeners() {
        this.nav.addEventListener('click', this.onNavClick.bind(this));
        this.viewport.addEventListener('scroll', this.debouncedOnScroll.bind(this));
        this.viewport.addEventListener('resize', this.debouncedOnScroll.bind(this));
        this.resizeObserver.observe(this.slides[0]);
      }
      onScroll() {
        this.reachedEnd = this.viewport.scrollWidth - this.viewport.offsetWidth - this.viewport.scrollLeft <= 1;
        this.onNavDisabled();
      }
      onNavClick(e) {
        const btn = e.target.closest('.flickity-nav');
        if (!btn) {
          return;
        }

        if (btn.name == 'next') {
            this.scrollPos = this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
        } else if (btn.name == 'prev') {
            this.scrollPos = this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
        }

        this.viewport.scrollTo({
          left: this.scrollPos,
          behavior: "smooth"
        });
      }
      onNavDisabled() {
        if (this.navPrev) {
          this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
        }
        if (this.navNext) {
          this.navNext.disabled = this.reachedEnd ? 1 : 0;
        }
      }
      centerArrows() {
        let first_cell = this.slides[0],
          max_height = 0,
          image_height = 0;
        if (first_cell.querySelector('.product-card-image')) {
          image_height = first_cell.querySelector('.product-card-image').clientHeight;
        } else if (first_cell.querySelector('.gallery--item')) {
          image_height = this.slides[1].querySelector('.product-card-image').clientHeight;
        }
        if (image_height > 0) {
          this.slides.forEach((item, i) => {
            if (item.clientHeight > max_height) {
              max_height = item.clientHeight;
            }
          });
  
          if (max_height > image_height) {
            let difference = (max_height - image_height) / -2;
  
            this.navPrev.style.transform = 'translateY(' + difference + 'px)';
            this.navNext.style.transform = 'translateY(' + difference + 'px)';
          }
        }
      }
    }
    customElements.define('collection-scroll-lg', CollectionScroll);
}